import { render, staticRenderFns } from "./index2.vue?vue&type=template&id=65b7f79c&scoped=true"
import script from "./index2.vue?vue&type=script&lang=js"
export * from "./index2.vue?vue&type=script&lang=js"
import style0 from "./index2.vue?vue&type=style&index=0&id=65b7f79c&prod&scoped=true&lang=css"
import style1 from "./index2.vue?vue&type=style&index=1&id=65b7f79c&prod&scoped=true&lang=css"
import style2 from "./index2.vue?vue&type=style&index=2&id=65b7f79c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65b7f79c",
  null
  
)

export default component.exports